import { ResponseBase, Sauna } from "@/models";
import axios from "axios";

export default class SaunaService {
    public async Reserve(accountId: number, saunaId: number, sauna: string, dayIndex: number, time: string, apartmentId: number): Promise<ResponseBase> { 
        const result = (await axios.post<ResponseBase>("sauna/reserve",
        { accountId, saunaId, sauna, dayIndex, time, apartmentId })).data;

        return result;
    }

    public async RemoveReservation(accountId: number, saunaId: number, sauna: string, dayIndex: number, time: string, apartmentId: number): Promise<ResponseBase> {
        const result = (await axios.post<ResponseBase>("sauna/remove-reservation",
        { accountId, saunaId, sauna, dayIndex, time, apartmentId })).data;

        return result;
    }

    public async GetSaunas(housingCompanyId: number): Promise<Sauna[]> {
        const result = (await axios.get("sauna", { params: { housingCompanyId }})).data;

        return result;
    }
}
